/* Educational filter-response model. Authored presets are not product targets.
 * Coefficients: W3C Audio EQ Cookbook (RBJ). No audio playback or processing.
 */
(function(g){'use strict';
 function coefficients(f,fs=96000){
  if(!f||!['peak','lowShelf','highShelf'].includes(f.type)||!Number.isFinite(f.hz)||f.hz<=0||f.hz>=fs/2||!Number.isFinite(f.gain)||Math.abs(f.gain)>24)throw Error('Invalid EQ filter');
  const A=Math.pow(10,f.gain/40),w=2*Math.PI*f.hz/fs,c=Math.cos(w),s=Math.sin(w);
  let alpha,b0,b1,b2,a0,a1,a2;
  if(f.type==='peak'){
   if(!(f.Q>0))throw Error('Positive Q required');alpha=s/(2*f.Q);
   b0=1+alpha*A;b1=-2*c;b2=1-alpha*A;a0=1+alpha/A;a1=-2*c;a2=1-alpha/A;
  }else{
   if(!(f.S>0&&f.S<=1))throw Error('Shelf slope must be in (0,1]');
   alpha=s/2*Math.sqrt((A+1/A)*(1/f.S-1)+2);const t=2*Math.sqrt(A)*alpha;
   if(f.type==='lowShelf'){b0=A*((A+1)-(A-1)*c+t);b1=2*A*((A-1)-(A+1)*c);b2=A*((A+1)-(A-1)*c-t);a0=(A+1)+(A-1)*c+t;a1=-2*((A-1)+(A+1)*c);a2=(A+1)+(A-1)*c-t;}
   else{b0=A*((A+1)+(A-1)*c+t);b1=-2*A*((A-1)+(A+1)*c);b2=A*((A+1)+(A-1)*c-t);a0=(A+1)-(A-1)*c+t;a1=2*((A-1)-(A+1)*c);a2=(A+1)-(A-1)*c-t;}
  }
  return {b:[b0/a0,b1/a0,b2/a0],a:[1,a1/a0,a2/a0]};
 }
 function response(filters,hz,fs=96000){
  if(!Number.isFinite(hz)||hz<=0||hz>=fs/2)throw Error('Frequency outside model domain');
  const w=2*Math.PI*hz/fs,c=Math.cos(w),s=Math.sin(w),c2=Math.cos(2*w),s2=Math.sin(2*w);
  let sum=0;for(const f of filters){const {b,a}=coefficients(f,fs);const nr=b[0]+b[1]*c+b[2]*c2,ni=-b[1]*s-b[2]*s2,dr=a[0]+a[1]*c+a[2]*c2,di=-a[1]*s-a[2]*s2;sum+=10*Math.log10((nr*nr+ni*ni)/(dr*dr+di*di));}return Math.abs(sum)<1e-9?0:sum;
 }
 function sample(filters,n=721,fs=96000){return Array.from({length:n},(_,i)=>{const hz=20*Math.pow(1000,i/(n-1));return {hz,value:response(filters,hz,fs)};});}
 function validate(points){if(!Array.isArray(points)||points.length<2)throw Error('Too few points');let last=0;for(const p of points){if(!Number.isFinite(p.hz)||p.hz<=last||!(p.value===null||Number.isFinite(p.value)))throw Error('Invalid curve');last=p.hz;}return true;}
 const api={coefficients,response,sample,validate};if(typeof module==='object'&&module.exports)module.exports=api;else g.LinsoulEQ=api;
})(typeof window==='undefined'?globalThis:window);
